// extracted by mini-css-extract-plugin
module.exports = {"action":"action__Nlf4D","icon":"icon__NyxYh","action-warning":"action-warning__RYq1w"};